import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useCustomerBrandDetail(id, params, config) {
  return useSWR(
    !!id
      ? {
          path: `/api/v1/customers/${id}/customer-brands`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
      ...config,
    },
  );
}

export default useCustomerBrandDetail;
